import React, { useState, useEffect } from 'react';
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import { Button, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { createOrderWithStripePayment } from '../actions/orderActions';
import Message from './Message';
import Loader from './Loader';

function StripePaymentForm({ history, clientSecret }) {
    const stripe = useStripe();
    const elements = useElements();
    const dispatch = useDispatch();

    const cart = useSelector(state => state.cart);
    const { cartItems, shippingAddress, paymentMethod } = cart;

    const orderCreate = useSelector(state => state.orderCreate);
    const { order, error, success, loading } = orderCreate;

    const [message, setMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (success) {
            history.push(`/order/${order._id}`);
        }
    }, [success, history, order]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!stripe || !elements) {
            return;
        }

        setIsLoading(true);

        const { error: submitError } = await elements.submit();

        if (submitError) {
            setMessage(submitError.message);
            setIsLoading(false);
            return;
        }

        const { paymentIntent, error: confirmError } = await stripe.confirmPayment({
            elements,
            clientSecret,
            redirect: 'if_required',
            confirmParams: {
                return_url: window.location.origin,
            },
        });

        if (confirmError) {
            if (confirmError.type === "card_error" || confirmError.type === "validation_error") {
                setMessage(confirmError.message);
            } else {
                setMessage("An unexpected error occurred.");
            }
        } else if (paymentIntent && paymentIntent.status === 'succeeded') {
            dispatch(createOrderWithStripePayment({
                orderItems: cartItems,
                shippingAddress: shippingAddress,
                paymentMethod: paymentMethod,
                itemsPrice: cart.itemsPrice,
                shippingPrice: cart.shippingPrice,
                taxPrice: cart.taxPrice,
                totalPrice: cart.totalPrice,
                stripePaymentId: paymentIntent.id,
            }));
        }

        setIsLoading(false);
    };

    return (
        <Form onSubmit={handleSubmit}>
            <PaymentElement id="payment-element" />
            <Button disabled={isLoading || !stripe || !elements} type="submit" className="mt-3 w-100">
                <span id="button-text">
                    {isLoading ? <Loader /> : "Pay now"}
                </span>
            </Button>
            {message && <Message variant="danger" className="mt-3">{message}</Message>}
            {error && <Message variant="danger" className="mt-3">{error}</Message>}
        </Form>
    );
}

export default StripePaymentForm;
